(function($) {
    class Login {
        constructor() {
            this.initSelectors();
            this.bindEvents();
        }

        initSelectors() {
            this.loginForm = $('#loginForm');
            this.emailInput = this.loginForm.find('input[name="login_email"]');
            this.passwordInput = this.loginForm.find('input[name="login_password"]');
            this.rememberMe = this.loginForm.find('input[name="remember_me"]');
            this.submitBtn = this.loginForm.find('button[type="submit"]');
            this.buttonText = this.submitBtn.find('.button-text');
            this.loader = this.submitBtn.find('.loader-1');
        }

        bindEvents() {
            /*this.emailInput.on('blur', (e) => {
                this.validateEmail($(e.target));
            });*/
            this.emailInput.on('focus', () => {
                this.removeErrorMessage(this.emailInput);
            });

            this.passwordInput.on('focus', () => {
                this.removeErrorMessage(this.passwordInput);
            });

            this.submitBtn.on('click', this.handleSubmit.bind(this));
        }

        showErrorMessage(inputElement, message) {
            let errorMsg = inputElement.siblings('.form__error-msg');
            if (errorMsg.length === 0) {
                errorMsg = $('<p class="form__error-msg"></p>');
                inputElement.after(errorMsg);
            }
            errorMsg.text(message);
        }

        removeErrorMessage(inputElement, container = null) {
            if (container) {
                container.find('.form__error-msg').remove();
            } else {
                inputElement.next('.form__error-msg').remove();
            }
        }

        isFormValid() {
            let isValid = true;

            if (this.emailInput.val().trim() === '') {
                isValid = false;
            }

            if (this.passwordInput.val().trim() === '') {
                this.showErrorMessage(this.passwordInput, 'Lozinka je obavezna');
                isValid = false;
            } else {
                this.removeErrorMessage(this.passwordInput);
            }

            return isValid;
        }

        validateEmail(inputElement) {
            const value = inputElement.val().trim();
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
            const isValid = emailRegex.test(value);

            if (value === '') {
                this.showErrorMessage(inputElement, 'Email adresa je obavezna');
                inputElement.removeClass('form__input-success');
                return false;
            } else if (!isValid) {
                this.showErrorMessage(inputElement, 'Nevažeća email adresa');
                inputElement.removeClass('form__input-success');
                return false;
            } else {
                this.removeErrorMessage(inputElement);
                inputElement.addClass('form__input-success');
                return true;
            }
        }

        setButtonLoading($button, isLoading) {
            if (isLoading){
                $button.find('.button-text').text(isLoading ? 'Prijava u tijeku...' : 'Prijavite se');
                $button.find('.loader-1').css('display', isLoading ? 'block' : 'none');
                $button.toggleClass('loading', isLoading);
                $button.prop('disabled', isLoading);
            }
            else {
                setTimeout(function () {
                    $button.find('.button-text').text(isLoading ? 'Prijava u tijeku...' : 'Prijavite se');
                    $button.find('.loader-1').css('display', isLoading ? 'block' : 'none');
                    $button.toggleClass('loading', isLoading);
                    $button.prop('disabled', isLoading);
                }, 2500);
            }
        }

        handleSubmit(e) {
            e.preventDefault();
            const $button = $(e.currentTarget);
            if (!this.isFormValid()) return;

            const email = this.emailInput.val();
            const password = this.passwordInput.val();
            const rememberMe = this.rememberMe.is(':checked');

            const ajaxData = {
                action: 'w4d_user_login',
                nonce: w4d_frontend_ajax.nonce,
                email: email,
                password: password,
                remember_me: rememberMe
            }

            $.post({
                url: w4d_frontend_ajax.ajax_url,
                data: ajaxData,
                beforeSend: () => this.setButtonLoading($button, true),
                success: (response) => {
                    if (response.success) {
                        if (response.data.redirect) {
                            window.location.href = response.data.redirect;
                        } else {
                            window.location.reload();
                        }
                    } else {
                        const errorContainer = this.passwordInput.parent();
                        this.showErrorMessage(this.passwordInput, response.data.message, errorContainer);
                    }
                },
                error: (xhr, status, error) => {
                    console.error('Login error:', error);
                    this.showErrorMessage(this.loginForm, 'Došlo je do greške prilikom prijave. Molimo pokušajte ponovno.');
                },
                complete: () => this.setButtonLoading($button, false)
            });
        }
    }

    $(document).ready(() => {
        new Login();
    });
})(jQuery);
